import { createMuiTheme } from '@material-ui/core/styles'

export const main = createMuiTheme({
  palette: {
    primary: { contrastText: '#ffffff', main: '#d51a2f' },
    secondary: { main: '#467e86' },
  },
})
